import { NormalizedSupportPolicy } from 'src/graphql/entities/support-policy/support-policy.utils';
import { ESCALATION_URGENCY_COLOR_MAP } from './escalation-utils';
import { POLICY_CATEGORY_ESCALATION, TYPE_COLOR_POLICIES_MAP } from './policy-constants';

const FALLBACK_POLICY_COLOR = '#9e9e9e';

export const getPolicyColor = (policy: NormalizedSupportPolicy): string => {
  if (policy.category === POLICY_CATEGORY_ESCALATION && policy.urgencyLevel) {
    return ESCALATION_URGENCY_COLOR_MAP[policy.urgencyLevel] ?? FALLBACK_POLICY_COLOR;
  }
  return TYPE_COLOR_POLICIES_MAP[policy.type] ?? FALLBACK_POLICY_COLOR;
};
